export default {
  supplier: {
    dashboard: {
      title: 'Dashboard',
      description: 'In this section you can find information about your catalog and activity',
    },
    catalog: {
      title: 'Catalog',
      description: 'In this section you can carry out specific searches on your catalog',
    },
    'request-information': {
      title: 'Request for Information',
      description: 'In this section you will get answers about your items',
    },
    report: {
      title: 'Catalog activity',
      description: 'In this section you will get information about your items',
    },
    newDashboard: {
      title: 'Dashboard',
      description: 'En esta sección podrá ver estadísticas sobre su empresa o unilink',
    },
    'supplier-admin': {
      title: 'Administration',
    },
    products: {
      title: 'Items',
      description: 'In this section you can edit or delete your Items',
    },
    users: {
      title: 'Users',
      description: 'In this section you can edit, activate or block your users',
    },
    search: {
      title: 'See my Catalog',
      description: 'In this section you can see what is in your catalog',
    },
    admin: {
      title: 'Manage my catalog',
      description: 'In this section you can create, edit or delete items from your catalog',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/routes/supplier.js